import Swal, {SweetAlertIcon} from 'sweetalert2'

// Restore scroll when SweetAlert closes
const restoreScroll = () => {
  document.body.style.overflow = ''
  document.body.style.paddingRight = ''
}

export const showMessage = (
  title: string,
  icon: SweetAlertIcon | string,
  onConfirm?: () => void
) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm()
    }
  }

  Swal.fire({
    title,
    icon: icon as SweetAlertIcon,
    confirmButtonText: 'OK',
    allowOutsideClick: true,
    allowEscapeKey: true,
  }).then((result) => {
    restoreScroll() // Fix scroll after closing alert
    if (result.isConfirmed) handleConfirm()
  })
}

export const showConfirmation = (
  text: string,
  confirmText: string,
  cancelText: string,
  onConfirm: () => void,
  onCancel: () => void
) => {
  Swal.fire({
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#0066B3',
    cancelButtonColor: '#F1416C',
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    allowOutsideClick: true,
    allowEscapeKey: true,
    preConfirm: onConfirm,
  }).then(() => {
    restoreScroll() // Fix scroll after closing confirm dialog
  })
}
